var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteForever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 22C9 23.1 9.9 24 11 24H19C20.1 24 21 23.1 21 22V12C21 10.9 20.1 10 19 10H11C9.9 10 9 10.9 9 12V22ZM12.17 14.17C12.56 13.78 13.19 13.78 13.58 14.17L15 15.59L16.42 14.17C16.81 13.78 17.44 13.78 17.83 14.17C18.22 14.56 18.22 15.19 17.83 15.58L16.41 17L17.83 18.42C18.22 18.81 18.22 19.44 17.83 19.83C17.44 20.22 16.81 20.22 16.42 19.83L15 18.41L13.58 19.83C13.19 20.22 12.56 20.22 12.17 19.83C11.9827 19.6432 11.8775 19.3895 11.8775 19.125C11.8775 18.8605 11.9827 18.6068 12.17 18.42L13.59 17L12.17 15.58C11.78 15.2 11.78 14.56 12.17 14.17ZM18.5 7L17.79 6.29C17.61 6.11 17.35 6 17.09 6H12.91C12.65 6 12.39 6.11 12.21 6.29L11.5 7H9C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9H21C21.55 9 22 8.55 22 8C22 7.45 21.55 7 21 7H18.5Z",
    fill: "#E62E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteForever);
export default __webpack_public_path__ + "static/media/delete_forever.2398146758ae24dbb6c4c4de11c8545e.svg";
export { ForwardRef as ReactComponent };